// export const $SERVER = "http://localhost:8080";

export const $SERVER = "https://le-1755.herokuapp.com";

export const COLOR_1755 = "#556341"; // #2b2b29

export const COLOR_ACARCIARA = "#556341";

// 75 = sweet spot avec Cloudinary : source nette pour les transformations
// `f_auto,q_auto:eco`, upload raisonnable (~250KB après resize), storage
// Cloudinary modeste. Avant : 40 (héritage base64-en-DB, trop agressif).
export const COMPRESSION_QUALITY = 75;
